export default function initImageZoom() {
  Alpine.data('imageZoom', () => ({
    zoomedIn: false,
    zoomIn(event: MouseEvent) {
      this.$el.classList.add('zooming');
      const image = this.$el.querySelector('img') as HTMLElement;

      const scale = 3; // Zoom level
      const rect = this.$el.getBoundingClientRect();

      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = `scale(${scale})`;
    },
    zoomOut() {
      this.$el.classList.remove('zooming');
      const image = this.$el.querySelector('img') as HTMLElement;
      image.style.removeProperty('transformOrigin');
      image.style.removeProperty('transform');
    },
  }));
}
